import React from 'react';
import { connect } from 'react-redux';

var GoogleMap = React.createClass({
    propTypes: {
        children: React.PropTypes.node,
        street: React.PropTypes.string,
        number: React.PropTypes.string,
        plz: React.PropTypes.string,
        ort: React.PropTypes.string
    },
    componentDidMount: function() {
        var geocoder = new google.maps.Geocoder();
        var address = `${this.props.street} ${this.props.number} ${this.props.plz} ${this.props.ort}`;
        geocoder.geocode( { 'address': address}, (results, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
                this.map = new google.maps.Map(this.refs.mapContainer, {
                    zoom: 16,
                    center: results[0].geometry.location,
                    navigationControl: false,
                    mapTypeControl: false,
                    draggable: false,
                    zoomControl: false,
                    scaleControl: false,
                    scrollwheel: false,
                    disableDoubleClickZoom: true
                });
                new google.maps.Marker({
                    map: this.map,
                    position: results[0].geometry.location,
                    animation: google.maps.Animation.DROP
                });
            }
        });
    },
    render: function() {
        return (
            <div className="map-wrapper">
                <div className="map-content">
                    {this.props.children}
                </div>
                {/* <div ref="mapContainer" id="map-container"></div> */}
            </div>
        );
    }
});

const mapStateToProps = (state) => {
    return {
        plz: state.company.address.plz,
        ort: state.company.address.ort,
        street: state.company.address.street,
        number: state.company.address.number
    };
};

export default connect(mapStateToProps)(GoogleMap);



// WEBPACK FOOTER //
// ./src/js/components/GoogleMap.js